import { PrimaryNavOption } from '../../../models/primary-nav-option';
import { determineActiveRoute } from '../utils/determine-active-route';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { SubscriptionManager } from '@tmx/core';
import { AppShellService } from '@tmx/modus-operandi';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { distinctUntilChanged, filter, map } from 'rxjs';

@Component({
  selector: 'nav-option',
  templateUrl: './nav-option.component.html',
  styleUrls: ['./nav-option.component.scss'],
  imports: [TooltipModule, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavOptionComponent implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  private readonly cd = inject(ChangeDetectorRef);
  private readonly sm = new SubscriptionManager();
  private readonly appShellService = inject(AppShellService);

  @Input() option: PrimaryNavOption | null = null;
  active = false;
  navigateIfOutOfRoute(option: PrimaryNavOption) {
    return this.active ? null : option.routerLink;
  }
  sideNavOpen = this.appShellService.sideNavOpen;

  ngOnInit() {
    this.active = determineActiveRoute(this.option?.routerLink ?? '');

    this.sm.manage = this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        ),
        map((event) => event.url),
        distinctUntilChanged()
      )
      .subscribe(() => {
        this.active = determineActiveRoute(this.option?.routerLink ?? '');
        this.cd.markForCheck();
      });
  }

  ngOnDestroy() {
    this.sm.unsubscribe();
  }
}
